import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';

import type { ThankYouSubComponentProps } from '.';

import conf from '../../../conf';
import ExternalLink from '../../external-link';
import { mrsText } from '../constants';

const SetUpWrapper = styled.main`
  button {
    border-radius: 21px;
    font-size: 18px;
    font-weight: bold;
    height: 42px;
    line-height: 24px;
    margin-top: 20px;
    width: 155px;
  }
`;

const SetUpReturns = ({ activeFlow, accountId = null }: ThankYouSubComponentProps) => {
  const { setupText1, setupText2 } = mrsText;

  const returnsUrl = accountId ? `${conf.CUP_URL}/cup/a/${accountId}/returns-provisioning` : `${conf.CUP_URL}/returns`;

  return (
    <SetUpWrapper className='flex justify-content-center text-center align-items-center'>
      <SRow>
        <SCol span='12' className='pad-top-lg pad-bottom-lg'>
          <h1 data-ref='buy.returns-thankyou.setup-returns.header'>
            {t('client.headings.now')}
            {"it's"}
            {t('client.headings.time-to-set-up-returns')}
          </h1>
          <h3 data-ref='buy.returns-thankyou.setup-returns.setup-text' className='alt pad-top-sm'>
            {setupText1}
          </h3>
          <h3 data-ref='buy.returns-thankyou.setup-returns.setup-subtext' className='alt pad-bottom-sm'>
            {setupText2}
          </h3>
          {!/net-new/.test(activeFlow || '') && (
            <ExternalLink
              data-ref='buy.returns-thankyou.setup-returns.go-to-returns.link'
              className='button primary'
              href={returnsUrl}
            >
              {t('client.general.go-to-returns')}
            </ExternalLink>
          )}
        </SCol>
      </SRow>
    </SetUpWrapper>
  );
};
export default SetUpReturns;
